import useBaseConfiguration from '../base/baseConfiguration'
import useBaseSettings from '../base/baseSettings'
import useBaseSpotConfiguration from '../base/baseSpotConfiguration'
import useBaseMapConfiguration from '../base/baseMapConfiguration'
import useBaseProducts from '../base/baseProducts'
import useBaseUserConfiguration from '../base/baseUserConfiguration'
import useBaseContainerConfiguration from '../base/baseContainerConfiguration'
import useBaseAdConfiguration from '../base/baseAdConfiguration'

import useParameters from './shared/appUrlParameters'
import useAppConfiguration from './prod/appConfiguration'
import useAppMapConfiguration from './shared/appMapConfiguration'
import useAppSpotConfiguration from './shared/appSpotConfiguration'
import useAppContainerConfiguration from './shared/appContainerConfiguration'
import useAppSettings from './shared/appSettings'
import useAppProducts from './shared/appProducts'
import useAppUserConfiguration from './prod/appUserConfiguration'
import useAppAdConfiguration from './shared/appAdConfiguration'

import useJweatherGlobalsTransformer from './shared/appJweatherGlobalsTransformer'
import useBaseJweatherConfig from '../base/baseJweatherConfig'
import useAppJweatherConfig from './shared/appJweatherConfig'

import { deepMerge } from '@/helpers/deepMerge'

window.$App = window.$App || {}
window.$App.globals = window.$App?.globals || {}
window.jweather = window.jweather || {}

const parameters = useParameters()

const baseConfiguration = useBaseConfiguration(parameters)
const appConfiguration = useAppConfiguration(parameters)
const siteConfiguration = window.$App.globals.configuration || {}

const baseUserConfiguration = useBaseUserConfiguration(parameters)
const appUserConfiguration = useAppUserConfiguration(parameters)
const siteUserConfiguration = window.$App.globals.user || {}

const baseSpotConfiguration = useBaseSpotConfiguration(parameters)
const appSpotConfiguration = useAppSpotConfiguration(parameters)
const siteSpotConfiguration = window.$App.globals.spot || {}

const baseContainerConfiguration = useBaseContainerConfiguration(parameters)
const appContainerConfiguration = useAppContainerConfiguration(parameters)
const siteContainerConfiguration = window.$App.globals.containers || {}

const baseMapConfiguration = useBaseMapConfiguration(parameters)
const appMapConfiguration = useAppMapConfiguration(parameters)
const siteMapConfiguration = window.$App.globals.map || {}

const baseSettings = useBaseSettings(parameters)
const appSettings = useAppSettings(parameters)
const siteSettings = window.$App.globals.settings || {}

const baseProducts = useBaseProducts(parameters)
const appProducts = useAppProducts(parameters)
const siteProducts = window.$App.globals.products || {}

window.$App.globals.configuration = deepMerge( {}, baseConfiguration, appConfiguration, siteConfiguration )
window.$App.globals.map = deepMerge( {}, baseMapConfiguration, appMapConfiguration, siteMapConfiguration )
window.$App.globals.spot = deepMerge( {}, baseSpotConfiguration, appSpotConfiguration, siteSpotConfiguration )
window.$App.globals.settings = deepMerge({}, baseSettings, appSettings, siteSettings)
window.$App.globals.products = deepMerge({}, baseProducts, appProducts, siteProducts)
window.$App.globals.user = deepMerge( {}, baseUserConfiguration, appUserConfiguration, siteUserConfiguration )
window.$App.globals.containers = deepMerge( {}, baseContainerConfiguration, appContainerConfiguration, siteContainerConfiguration )

// Ad configuration needs to be done after the merging of the configuration globals to maker sure the brand is set
const baseAdConfiguration = useBaseAdConfiguration({ ...window.$App.globals.configuration, ...window.$App.globals.user })
const appAdConfiguration = useAppAdConfiguration(parameters)
const siteAdConfiguration = window.$App.globals.ads || {}
window.$App.globals.ads = deepMerge( {}, baseAdConfiguration, appAdConfiguration, siteAdConfiguration )

useJweatherGlobalsTransformer(parameters)
useBaseJweatherConfig(parameters)
useAppJweatherConfig(parameters)